import React, { ReactNode } from 'react';
import dayjs from 'dayjs';
import { ApiPackageModel } from '@ibe/api';
import { ConfigModel } from '@ibe/services';
import isBetween from 'dayjs/plugin/isBetween';
import { HighlightDatesInformation } from '../DateRangeInput/DateRangeInputProps';

dayjs.extend(isBetween);

const renderDayContents = (
  config: ConfigModel,
  availabilityPackage?: ApiPackageModel,
  includeDates?: Date[],
  highlightDatesInformation?: HighlightDatesInformation,
  withColorCodedAvailability?: boolean
): ((dayOfMonth: number, fullDate?: Date) => ReactNode) => (
  dayOfMonth: number,
  fullDate?: Date
): ReactNode => {
  let availabilityClassName = '';
  const isWithOfferHighlightIcon = highlightDatesInformation?.dateRanges?.some(dateRange => {
    return dayjs(fullDate).isBetween(
      dayjs(dateRange?.startDate),
      dayjs(dateRange?.endDate),
      'day',
      '[]'
    );
  });

  if (withColorCodedAvailability) {
    availabilityClassName = getAvailabilityClassName(
      config,
      availabilityPackage,
      includeDates,
      fullDate
    );
  }

  return (
    <div className={`day-contents ${availabilityClassName}`}>
      <span className="offer-highlight-day">{dayOfMonth}</span>
      {isWithOfferHighlightIcon ? (
        <span className="offer-highlight-icon">{highlightDatesInformation?.highlightIcon}</span>
      ) : null}
    </div>
  );
};

const getAvailabilityClassName = (
  config: ConfigModel,
  availabilityPackage?: ApiPackageModel,
  includeDates?: Date[],
  fullDate?: Date
): string => {
  let availabilityClassName = 'customDayContents';

  const relatedPackageDetail = availabilityPackage?.packageDetails?.find(packageDetail =>
    dayjs(packageDetail.startDate).isSame(dayjs(fullDate))
  );

  const threshold = config.availabilityCalendarThreshold;

  if (relatedPackageDetail && threshold) {
    const dateAvailability = relatedPackageDetail.totalAvailability;

    if (dateAvailability) {
      const isDateNotIncluded =
        fullDate && includeDates && !includeDates.some(val => val.getTime() === fullDate.getTime());
      if (!isDateNotIncluded) {
        if (dateAvailability > threshold) {
          availabilityClassName = 'customDayContents_available';
        } else if (dateAvailability <= threshold && dateAvailability > 0) {
          availabilityClassName = 'customDayContents_busy';
        } else if (dateAvailability == 0) {
          availabilityClassName = 'customDayContents_unavailable';
        }
      }
    }
  }

  return availabilityClassName;
};

export default renderDayContents;
